const signupForm = document.querySelector('.signup__form')
const signupButton = document.querySelector('.signup__button')

if (signupForm && signupButton) {
  signupForm.addEventListener('submit', function () {
    signupButton.setAttribute('disabled', '')
  })
}
